import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { PalantirStatusColor } from '../../../../../shared/interfaces/status.interface';
import { PalantirStatusColorEnum } from '../../../../../shared/interfaces/status.interface';
import { PalantirTextComponent } from '../../../../text/text.component';

@Component({
  selector: 'palantir-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirTextComponent],
})
export class PalantirStatusComponent {
  @Input({ required: true }) public value!: PalantirStatusColor;

  @Input({ required: true }) public label!: string;

  public get status(): PalantirStatusColorEnum | null {
    if (!this.value) {
      return PalantirStatusColorEnum.default;
    }

    return PalantirStatusColorEnum[this.value];
  }
}
